import api from './api';

export const getAtendimentoEmAndamento = async () => {
  try {
    const response = await api.get('/Atendimento/EmAndamento');
    return response;
  } catch (error) {
    return { error };
  }
};

export const getSolicitacaoEmAndamento = async () => {
  try {
    const response = await api.get('/SolicitacaoAtendimento/EmAndamento');
    return response;
  } catch (error) {
    return { error };
  }
};

export const postINovoAtendimento = async () => {
  try {
    const response = await api.post('/Atendimento/IniciarAtendimentoInterno');
    return response;
  } catch (error) {
    return error;
  }
};

export const postReanalisarSolicitacao = async idIntegracao => {
  const response = await api.post(`/Atendimento/IniciarReanalise/${idIntegracao}`);
  return response;
};

export const getImgMotoristaCNH = async cpf => {
  try {
    const response = await api.get(`/ImagemOcr/MotoristaCNH?cpf=${cpf}`);
    return response;
  } catch (error) {
    return { error };
  }
};

export const getImgSelfieMotorista = async cpf => {
  try {
    const response = await api.get(`/ImagemOcr/MotoristaSelfie?cpf=${cpf}`);
    return response;
  } catch (error) {
    return { error };
  }
};

export const getImgsVeiculos = async placa => {
  try {
    const response = await api.get(`/ImagemOcr/Veiculo?placa=${placa}`);
    return response;
  } catch (error) {
    return { error };
  }
};
